import { render, staticRenderFns } from "./TheMainMenuProblemButton.vue?vue&type=template&id=3be6d33e&"
import script from "./TheMainMenuProblemButton.vue?vue&type=script&lang=ts&"
export * from "./TheMainMenuProblemButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports